'use client';

import { useEffect } from 'react';

function isEditableElement(node: EventTarget | null): node is HTMLElement {
  if (!(node instanceof HTMLElement)) return false;
  if (node instanceof HTMLInputElement) return true;
  if (node instanceof HTMLTextAreaElement) return true;
  return node.isContentEditable;
}

export function useBlurOnOutsidePointer(): void {
  useEffect(() => {
    const handlePointerDown = (event: PointerEvent): void => {
      const active = document.activeElement;
      if (!isEditableElement(active)) return;
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (active.contains(target)) return;
      active.blur();
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
    };
  }, []);
}
